import { render, staticRenderFns } from "./CompanyCrawlRequests.vue?vue&type=template&id=0372b364&"
import script from "./CompanyCrawlRequests.vue?vue&type=script&lang=js&"
export * from "./CompanyCrawlRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports